import React from 'react';
import { motion } from 'framer-motion';
import { TwoColumnSlide as TwoColumnSlideType } from '../../types';
import { SlideContainer, SlideTitle } from '../common/SlideComponents';

interface TwoColumnSlideProps {
  content: TwoColumnSlideType;
  title?: string;
  speakerNotes?: string;
}

export const TwoColumnSlide: React.FC<TwoColumnSlideProps> = ({
  content,
  title,
  speakerNotes
}) => {
  return (
    <SlideContainer>
      <div className="flex flex-col h-full">
        {title && (
          <SlideTitle className="text-5xl mb-16 text-center">
            {title}
          </SlideTitle>
        )}
        
        <div className="flex-1 flex items-center">
          <div className="grid grid-cols-2 gap-16 w-full">
            <motion.div
              className="space-y-8"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h2 className="text-3xl font-semibold text-deep-slate mb-6">
                {content.leftColumn.title}
              </h2>
              <div className="space-y-6">
                {content.leftColumn.content.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                  >
                    <p className="body-large text-soft-black leading-relaxed">
                      {item}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            
            <motion.div
              className="space-y-8"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h2 className="text-3xl font-semibold text-deep-slate mb-6">
                {content.rightColumn.title}
              </h2>
              <div className="space-y-6">
                {content.rightColumn.content.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.6 + index * 0.1 }}
                  >
                    <p className="body-large text-soft-black leading-relaxed">
                      {item}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      
      {speakerNotes && (
        <div className="absolute bottom-4 left-4 opacity-0 hover:opacity-100 transition-opacity duration-200">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg p-3 text-sm text-warm-gray max-w-xs">
            <strong>Speaker Notes:</strong> {speakerNotes}
          </div>
        </div>
      )}
    </SlideContainer>
  );
};